import { render, staticRenderFns } from "./server.vue?vue&type=template&id=247adb3f&"
import script from "./server.vue?vue&type=script&lang=ts&"
export * from "./server.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports